export default {
    unknown: "Sconosciuto",
    failed: "Operazione non riuscita",
    success: "Operazione eseguita con successo",
    trustHubInfo: "TrustHub è costruito con la più avanzata e robusta tecnologia sulla sicurezza ed è una delle applicazioni più sicure dove gestire i propri dati in ambiente completamente conforme al GDPR.",
    onboard: "Onboard",
    authentication: "Autenticazione",
    restore: "Restore",
    spanish: "Spagnolo",
    english: "Inglese",
    italian: "Italiano",

    loginAuthenticateWith: "con Username e Password",
    loginWelcomeBack: "Bentornato, esegui il login al tuo account fornendo le tue",
    loginWelcomeBackCredentials: "credenziali",
    loginUsername: "Username",
    loginUsernameRequired: "campo Username obbligatorio",
    loginPassword: "Password",
    loginPasswordRequired: "campo Password obbligatorio",
    loginForgotPassword: "Ho dimenticato la password",
    loginRememberMe: "Ricorda le credenziali",
    loginAgree: "Per proseguire in TrustHub accetta il",
    loginAgreeService: "Service Agreement",
    loginAgreeAnd: "e la",
    loginAgreePolicy: "Privacy Policy",
    loginSubmit: "Accesso",
    loginOrChooseDiffAuthOption: "o scegli un' opzione differente di autenticazione dal menu laterale",
    loginSubscribeTrial: "Registrati per una prova gratuita",
    loginWarningAcceptLicense: "Devi prima accettare i termini di licenza ed il contratto",
    loginSucceeded: "Sessione iniziata",
    loginReCaptchaCheck: "Spuntare non sono un Robot",

    dashboard: "Dashboard",
    candidate: "Candidati",
    employee: "Lavoratori",
    employer: "Datori di lavoro",
    recruit: "Ricerca",
    contract: "Contratti",
    settings: "Settings",
    help: "Aiuto",

    authenticate: "Autenticazione",
    sessionLost: "Sessione scaduta",
    search: "Ricerca",
    clear: "Cancella",
    newCandidate: "Nuovo candidato",
    newEmployer: "Nuovo datore di lavoro",
    newContract: "Nuovo contratto",
    continue: "Continua",
    resident: "Residente in",
    residentErrorMessage: "Indicare un indirizzo di residenza valido",
    street: "Via",
    zipCode: "Cap",
    domicile: "Domicilio",
    infDomicile: "Da compilare se diverso dalla residenza",
    infOtherwiseDomicile: "Altrimenti si dovrebbe compilare in automatico",
    preference: "Preferenza",
    geographicalAvailability: "Disponibilità geografica",
    withinKmFromHome: "Distanza in KM dal domicilio",
    email: "Email",
    mobile: "Cellulare",
    streetErrorMessage: "Indicare un indirizzo valido",
    provinceErrorMessage: "Selezionare una provincia",
    zipCodeErrorMessage: "Indicare il CAP",
    emailErrorMessage: "Indicare un indirizzo mail",
    invalidEmailErrorMsg: "Indicare un indirizzo mail formalmente valido",
    mobileErrorMessage: "Indicare un numero di cellulare",
    invalidMobileErrorMsg: "Indicare un numero di cellulare formalmente valido",
    invalidWordOnlyErrorMsg: "Inserire unicamente lettere e spazi",
    invalidAlphanumericErrorMsg: "Digitare un valore alfanumerico valido",
    invalidDateErrorMsg: "Indicare una data formalmente valida",
    invalidPositiveNumberErrorMsg: "Indicare un numero valido",

    //*-----------------------* Steps name, description *-----------------------*

    registryStepName: "Anagrafica",
    personalDataText: "Dati anagrafici",
    personalDataDescriptionText: "Dati anagrafici del candidato",

    residenceText: "Residenza",
    residenceDescriptionText: "Luogo di residenza",

    contactsText: "Contatti",
    contactsDescriptionText: "Email e cellulare di contatto",

    tasksStepName: "Mansioni",
    employeeSectionAvailabilityOfTasksRequiredText: "Disponibilita’ mansioni richieste",
    employeeSectionAvailabilityOfTasksRequiredDescriptionText: "E' possibile barrare anche più mansioni",

    contractStepName: "Contratto",
    contractualTypeStepText: "Tipologia contrattuale",
    contractualTypeDescriptionText: "Tipologia contratturale",

    contractAgreementDescriptionText: "Tipologia accordo contratturale",

    availabilityStepName: "Disponibilità",
    availabilityToWorkText: "Disponibilità a lavorare",
    availabilityToWorkDescriptionText: "Preferenze e disponibilità lavorative",

    otherStepName: "Altro",
    otherInformationStepName: "Altre informazioni",
    otherInformationText: "Altre informazioni",
    otherInformationStepDescriptionText: "Altre informazioni contratturali",

    otherInformationDescriptionText: "Informazioni addizionali",

    experiencesStepName: "Esperienze",
    workExperiences: "Esperienze lavorative",
    workExperiencesDescription: "Esperienze lavorative pregresse",

    languagesStepName: "Lingue",
    knowledgeItalianLanguage: "Lingua italiana",
    knowledgeItalianLanguageDescription: "Conoscenza della lingua italiana",

    employerKnowledgeItalianLanguageDescription: "Livello conoscienza lingua italiana",

    trainingStepName: "Formazione",
    houseWorkTrainingText: "Formazione lavoro domestico",
    houseWorkTrainingDescriptionText: "Percorsi formativi specifici",

    capacityStepName: "Capacità",
    employeeAvailabilityToUseForToolsText: "Capacita’ di utilizzo di strumenti per persone non autosufficienti",
    employeeAvailabilityToUseForToolsDescriptionText: "Capacità specifiche per non autosufficienti",

    otherRequestsStepText: "Altre richieste",
    otherRequestsStepDescriptionText: "Altre richieste particolari",

    assessmentStepName: "Valutazione",
    evaluationByTheOperatorStepText: "Valutazione",
    evaluationByTheOperatorStepDescriptionText: "A cura dell'operatore",

    applicantStepName: "Richiedente",
    applicantDataStepText: "Dati richiedente",
    applicantDataStepDescriptionText: "Dati reperibilità del richiedente",

    employerRegistryStepsText: "Anagrafica datore di lavoro",
    employerRegistryStepDescriptionText: "Dati anagrafici completi del datore di lavoro",

    residencePermitStepName: "Titolo di soggiorno",
    residencePermitText: "Titolo di soggiorno (solo per soggetti di nazionalita’ extra UE)",
    residencePermitDescriptionText: "Solo per soggetti di nazionalità extra UE",

    addressStepName: "Indirizzo",
    addressOfTheEmployerText: "Indirizzo del datore di lavoro",
    addressOfTheEmployerDescriptionText: "Indirizzo completo del datore di lavoro",

    workplace: "Luogo di lavoro",
    workplaceDescription: "Dove si svolgerà la prestazione richiesta",

    workplaceAddressDescription: "Indirizzo luogo di lavoro",

    informationStepName: "Informazioni",
    otherInformationForRecruitment: "Altre informazioni per l'assunzione",
    otherInformationForRecruitmentDescription: "Altre indicazioni utili per l'assunzione",

    homeStepName: "Casa",
    houseSheetText: "Scheda della casa",
    houseSheetDescriptionText: "Caratteristiche della casa",

    employerSummaryText: "Riepilogo",
    employerSummaryDescriptionText: "A cura dell'operatore",

    babySisterStepName: "Baby sitter",
    familyAsstBabySister: "Assistente familiare (Baby sitter)",
    familyAsstBabySisterDescription: "Assistente familiare per bambini",

    specificTasksStepName: "Mansioni specifiche",
    otherWorksDoChildrenText: "Altri lavori da svolgere con i bambini",
    otherWorksDoChildrenDescriptionText: "Altre attività da svolgere con bambini",

    requirementsStepName: "Requisiti",
    requirementsRequired: "Requisiti richiesti",
    requirementsRequiredDescription: "Requisiti specifici richiesti",

    tasksRequiredText: "Mansioni richieste",
    tasksRequiredDescriptionText: "Principali mansioni richieste",

    tasksRequiredDescription: "Specifici requisiti per non autosufficienti",

    limitationsStepName: "Limitazioni",
    notWantedFeatures: "Caratteristiche non gradite",
    notWantedFeaturesDescription: "Caratteristiche non gradite",

    selfSufficiencyStepName: "Autosufficienza",
    employerSectionCardForNonSelfSufficiencyText: "Scheda per la non autosufficienza",
    employerSectionCardForNonSelfSufficiencyDescriptionText: "Da compilare solo in caso di non autosufficienza",

    caretakerStepName: "Badante",
    familyAsstCare: "Assistente familiare (Badante)",
    familyAsstCareDescription: "Assistente familiare per adulti",

    otherWorksDoAssistantText: "Altri lavori da svolgere con l'assistito",
    otherWorksDoAssistantDescriptionText: "Altre attività da svolgere con l'assistito",

    partsStepName: "Le parti",
    selectEmployerAndEmployee: "Seleziona datore di lavoro e dipendente",
    selectEmployerAndEmployeeDescription: "Cliente e candidato selezionato",

    startOfRelationshipStepName: "Inizio rapporto",
    requestToStartWorkingRelationship: "Richiesta inizio rapporto di lavoro",
    requestToStartWorkingRelationshipDescription: "Data e modalità inizio rapporto",

    timetablesStepName: "Orari",
    weeklyWorkingHoursText: "Orario di lavoro settimanale",
    weeklyWorkingHoursDescriptionText: "Definizione orari di lavoro",

    restStepName: "Riposo",
    weeklyRest: "Riposo settimanale",
    weeklyRestDescription: "Giorno di riposo settimanale",

    remuneration: "Retribuzione",
    remunerationDescription: "Composione retribuzione mensile",

    deductions: "Trattenute",
    deductionsDescription: "Determinazione gestione trattenute",

    privacyStepName: "Privacy",
    privacy: "Caricamento Privacy Policy firmata",
    privacyDescription: "Documento sulla privacy",

    uploadPhoto: "Fotografia",
    uploadAPhoto: "Caricamento foto candidato",
    uploadPhotoDescription: "Immagine candidato",

    //*--------------------* Fields Name, Required messages *--------------------*
    enterNumber: 'Inserire il PIN',
    openApp: '1. Apri lapplicazione ',
    googleAuthenticator: 'di Google Autenticatore',
    mobileDevice: 'sul tuo dispositivo mobile.',
    downloadFor: '(Scarica per Android o IOS).',
    writeText: '2. Scrivi il',
    pinText: 'SPILLO',
    nextText: 'continuazione:',

    aliasText: "Alias",
    aliasIsRequiredText: "Campo Nome obbligatorio",

    firstNameText: "Nome",
    firstNameIsRequiredText: "Campo Nome obbligatorio",

    lastNameText: "Cognome",
    lastNameRequiredText: "Campo Cognome obbligatorio",

    fiscalCodeText: "Codice fiscale",
    fiscalCodeIsRequiredText: "Campo Codice Fiscale obbligatorio",

    birthDateText: "Data di nascita",
    birthDateIsRequiredText: "Campo Data di nascita obbligatorio",

    placeOfBirthText: "Luogo di nascita",
    placeOfBirthIsRequiredText: "Campo Luogo di nascita obbligatorio",

    cityText: "Città",
    cityOfBirthText: "Città di nascita",
    cityIsRequiredText: "Campo Città di nascita obbligatorio",

    provinceText: "Provincia",
    provinceOfBirthText: "Provincia di nascita",
    provinceIsRequiredText: "Selezione Provincia di nascita obbligatoria",

    countryText: "Nazione",
    countryIsRequiredText: "Selezione Nazione di nascita obbligatoria",

    countryOfBirthText: "Nazione di nascita",
    countryFieldRequired: "Selezione Nazione di nascita obbligatoria",

    countryPrefText: "Preferenza paese",
    ueIsRequiredText: "Selezione preferenza paese obbligatoria",

    idDocumentTypeText: "Tipo di documento identità",
    idDocumentTypeIsRequiredText: "Selezione Tipo di documento identità obbligatoria",

    numberText: "Numero",
    numberIsRequiredText: "Campo Numero obbligatorio",

    equippedWithAdrivingLicenseText: "Munito di patente di guida",
    driverLicenseIsRequiredText: "Selezione Munito di patente di guida obbligatoria",

    licenseNumberText: "N° Patente",
    licenseNumberIsRequiredText: "Campo N° Patente obbligatorio",

    expiryText: "Scadenza",
    expiryIsRequiredText: "Campo Scadenza obbligatorio",

    citizenshipText: "Cittadinanza",
    citizenshipIsRequiredText: "Campo Cittadinanza obbligatorio",

    typeOfCourseIsRequiredText: "Selezione Tipo di corso obbligatoria",

    durationIsRequiredText: "Campo Durata obbligatorio",

    placeIsRequiredText: "Campo Posto obbligatorio",

    sexText: "Sesso",
    sexIsRequiredText: "Selezione Sesso obbligatoria",

    residencePermitNumberText: "N° permesso di soggiorno",
    residencePermitNumberIsRequiredText: "Campo Nº permesso di soggiorno obbligatorio",

    releasedByText: "Rilasciato da",
    releasedByIsRequiredText: "Selezione Rilasciato da obbligatoria",

    explanatoryStatementText: "Motivazione",
    explanatoryStatementIsRequiredText: "Selezione Motivazione obbligatoria",

    otherExplanatoryStatementText: "Altra motivazione",
    otherExplanatoryStatementIsRequiredText: "Campo Altra motivazione obbligatorio",

    domesticPartnershipText: "Convivenza",

    timePeriodText: "Tempo",

    fromText: "Dalle",
    fromTimeIsRequiredText: "Campo Dalle obbligatorio",

    toText: "Alle",
    toTimeIsRequiredText: "Campo Alle obbligatorio",

    hoursText: "Ore",
    hoursIsRequiredText: "Campo Ore obbligatorio",

    workingHoursText: "Ore lavorative",

    dailyHourlyAvailabilityText: "Disponibilità oraria giornaliera",
    dailyHourlyAvailabilityIsRequiredText: "Campo Disponibilità oraria giornaliera obbligatorio",

    forReplacementText: "Per sostituzione",

    checkboxRequiredField: "Selezione obbligatoria, selezionare una o più opzioni",
    radioButtonRequiredField: "Selezione obbligatoria, selezionare un'opzione",

    //*--------------------* list options *--------------------*

    undeterminedText: "Indeterminato",
    determinedText: "Determinato",
    fullTimeText: "Full time",
    partTimeText: "Part time",
    nightPresenceText: "Presenza notturna",
    discontinuousNightPerformanceText: "Discontinue prestazioni notturne",
    forReplacementForHolidayReplacementText: "Per sostituzione festivi",
    forReplacementForReplacementInGeneralText: "Per sostituzione in generale",

    morningText: "Mattina",
    afternoonText: "Pomeriggio",
    mondayText: "Lunedi",
    tuesdayText: "Martedi",
    wednesdayText: "Mercoledi",
    thursdayText: "Giovedi",
    fridayText: "Venerdi",
    saturdayText: "Sabato",
    sundayText: "Domenica",

    identityCard: "Carta di Idendità",
    passport: "Passaporto",
    socialSecurityNumber: "Tessera Sanitaria",
    driverLicence: "Patente di guida",
    nonDichiarato: "Non dichiarato",
    campoObbligatorio: "* Il campo è obbligatorio",


    //*--------------------* others *--------------------*


    //*--------------------* FALTA ORDENAR *--------------------*

    weeklyRestDayText: "Giornata di riposo settimanale",
    anotherDayText: "Altra giornata",
    specialFoodNeedsText: "Particolari esigenze alimentari",
    specialFoodNeedsIsRequiredText: "Alimentazione speciale obbligatoria",
    inPossessionOfGreenPassText: "In possesso di green pass",
    allergicToAnimalsHairText: "Allergica al pelo di animale",
    ifYesToWhichText: "Se sì a quale",
    ifYesToWhichRequiredText: "campo Se Si, a quale obbligatorio",
    smokerText: "Fumatore",
    notesAllergiesOrOtherText: "Note (Allergie O Altro)",
    notesAllergiesOrOtherIsRequiredText: "Campo Note (Allergie o altro) obbligatorio",
    italianCookingCapacityText: "Capacità cucina Italiana",
    noteText: "Note",
    noteIsRequiredText: "Campo Note obbligatorio",
    carText: "Automunito",
    drivingExperienceText: "Esperienza guida",
    cityDrivingExperienceText: "Esperienza guida in città’",
    outSideTheCityText: "Fuori dalla città’",
    possibleWorkerRequestsText: "Eventuali richieste lavoratore",
    possibleWorkerRequestsIsRequiredText: "Campo Eventuali richieste del lavoratore obbligatorio",
    addressText: "Indirizzo",
    addressIsRequiredText: "Campo Indirizzo obbligatorio",
    typeOfHouseText: "Tipo di casa",
    otherTypeOfHouseText: "Altro tipo di casa",
    otherTypeOfHouseIsRequiredText: "Campo Altro tipo di casa obbligatorio",
    apartmentText: "Appartamento",
    villaText: "Villa",
    otherText: "Altro",
    numberOfRoomsText: "Numero stanze",
    otherNumberOfRoomsText: "Altro numero stanze",
    otherNumberOfRoomsIsRequiredText: "Campo Altro numero di stanze obbligatorio",
    numberOfBathroomsText: "Numero bagni",
    otherNumberOfBathroomsText: "Altro numero bagni",
    otherNumberOfBathroomsIsRequiredText: "Campo Altro numero di bagni obbligatorio",
    areasOfTheHouseText: "Aree della casa",
    areasOfTheHouseIsRequiredText: "Stanze richieste",
    teraceText: "Terrazzo",
    gardenText: "Giardino",
    otherAreasOfTheHouseText: "Altro aree della casa",
    otherAreasOfTheHouseIsRequiredText: "Campo Altre aree della casa obbligatorio",
    animalsText: "Animali",
    inCaseOfCohabitationText: "In caso di convivenza c’e’ la stanza autonoma per il lavoratore?",
    floorText: "Piano",
    floorIsRequiredText: "Campo Piano obbligatorio",
    elevatorText: "Ascensore",
    coincideText: "Coincide con la residenza del datore di lavoro",
    coincideContattiText: "Coincide con i contatti del richiedente",
    coincideResText: "Coincide con il richiedente",
    babySisterText: "Baby sitter",
    wakeUpAndFallAsleepText: "Svegliarli e addormentarli",
    prepareLunchDinnerAccordingFamilyText: "Preparargli il pranzo e la cena secondo le indicazioni della famiglia",
    takeThemSchoolOrKindergartenText: "Portarli a scuola o all'asilo ed andarli a prendere",
    makeCompanyByDayNightText: "Fargli compagnia di giorno e di notte",
    helpThemSchoolTasksText: "Aiutarli nei compiti scolastici",
    takeThemWalksActivitiesParkText: "Portarli a fare passeggiate, attività’ nel parco",
    accompanyThemSchoolExtraText: "Accompagnarli ad attivita’ scolastiche ed extrascolastiche",
    takeCareOfTheirPersonalText: "Curarne l’igiene personale, vestirli e svestirli",
    tripsText: "Viaggi",
    laundryAndIronText: "Bucato e stiro (vestiti dei bambini)",
    foodPreparationText: "Preparazione del vitto per tutta la famiglia",
    accommodationArrangementText: "Sistemazione dell’alloggio",
    survillanceAdminisrationDrugsText: "Vigilanza e/o somministrazione di farmaci secondo le indicazioni ricevute",
    accompanyThemPickThemAtText: "Accompagnarli ed andarli a prendere nei luoghi di ritrovo sportivo/ricreativo/terapie/amici/familiari/spesa/altro",
    helpingThemHouseHoldText: "Aiutarli nelle faccende domestiche",
    taskJobDutyText: "Mansione",
    taskJobDutyIsRequiredText: "mansioni richieste",
    weeklyWorkingHoursNoText: "Orario di lavoro settimanale N° ore",
    weeklyWorkingHoursNoIsRequiredText: "Campo Numero di ore settimanali obbligatorio",
    totalHoursText: "Totale ore",
    morningFromText: "Mattina dalle",
    morningToText: "Mattina alle",
    aftrnoonFromText: "Pomeriggio dalle",
    aftrnoonToText: "Pomeriggio alle",
    numberOfHoursText: "Numero ore",

    fillInAnotherTimeText: "Indicare un orario differente",

    availibilityToWorkWithText: "Disponibilità a lavorare",
    menText: "Uomini",
    womenText: "Donne",
    indifferentText: "Indifferente",
    nonSelfInsuficientText: "Non autosufficiente",
    childrenText: "Bambini",
    availabilityToMoveWithTheEmployerForShortPeriodsText: "Disponibilità’ a spostarsi con il datore di lavoro per brevi periodi",
    inTheHolidayPeriodsText: "Nei periodi di vacanza",

    periodPreferenceForHolidayEnjoymentText: "Preferenza periodo per il godimento ferie",
    availabilityAtAdditionalExtraOrdinaryHoursDuringWeekText: "Disponibilita a ore ordinarie aggiuntive/straordinarie durante la settimana",
    availabilityForExtraOrdinaryHolidayText: "Disponibilita’ a straordinari festivita’",
    employeeOtherInformationRequireTrainingDiplomaText: "In possesso diploma professionale 500 ore",

    birthOfPlaceText: "Luogo di nascita",
    trainingsText: "Formazioni",
    houseworkTrainingAttendedTrainingCoursesText: "Ha frequentato corsi di formazione relativi al lavoro domestico o all’assistenza familiare?",
    forWathTasksText: "Per quali mansioni",
    durationMonthsText: "Duration (Months)",
    addTrainingCourseText: "Aggiungi formazione",
    obtainingUni11766CertText: "Ha Ottenuto La Certificazione Uni 11766",
    dateIsRequiredText: "Data obbligatoria",

    maidText: "Colf",
    baysterText: "Baby Sitter",
    careTakerText: "Badante",
    typeOfCourseText: "Tipo di corso",
    durationText: "Durata",
    placeText: "Luogo",
    ifYesIndicateWhichText: "Se SI indicare quale:",

    notesText: "Note",
    notesIsRequiredText: "Campo Note obbligatorio",
    evaluation1To5Text: "Valutazione 1/5",
    evaluation1To5IsRequiredText: "Campo Valutazione obbligatorio",

    natureOfTheEmployerText: "Natura del datore di lavoro",
    physicalPersonText: "Persona fisica",
    religiousCommunityText: "Comunita’ religiosa",
    boardingSchoolText: "Convitto",
    secularPriestOfCatholicWorshipText: "Sacerdote secolare di culto cattolico",
    professionText: "Professione",
    professionIsRequiredText: "Campo Professione obbligatorio",

    allLevels: "Tutti i livelli",
    exclusiveInChargeOfHouseCleaning: "Addetto esclusivamente alle pulizie della casa",
    cookingAjdCookSupport: "Aiuto di cucina - supporto cuoco",
    assistantToPets: "Assistente ad animali domestici",
    commonWorker: "Operaio comune",
    generalMultifunctionalCollaborator: "Collaboratore generico polifunzionale (colf)",
    ironingManager: "Addetto alla stireria",
    gardener: "Giardiniere",
    driver: "Autista",
    familyAssistantAssistingSelfSufficientPeople: "Assistente familiare che assiste persone autosufficienti",
    cook: "Cuoco",
    workerExclusivelyInTheLaundry: "Addetto esclusivamente alla lavanderia",
    stableman: "Stalliere",
    cleaningAndWateringTheGreenAreas: "Addetto alla pulizia ed annaffiatura delle aree verdi",
    companyOfficer: "Addetto alla compagnia",
    guardianOfPrivateHouse: "Custode di abitazione privata",
    waiter: "Cameriere",
    qualifiedWorker: "Operaio qualificato",
    roomCleaner: "Addetto al riassetto camere",
    familyAssistantAssistingChildren: "Assistente familiare che assiste bambini (baby sitter)",
    familyAssistantAssistingNonSelfSufficientPeopleNotTrained: "Assistente familiare che assiste persone non autosufficiente (Badante Non formato/a)",
    administratorOfFamilyAssets: "Amministratore dei beni di famiglia",
    housekeeper: "Governante",
    headGardener: "Capo giardiniere",
    familyAssistantAssistingNonSelfSufficientPeopleTrained: "Assistente familiare che assiste persone non autosufficienti (formato)",
    trainedFamilyAssistantEducator: "Assistente familiare educatore formato",

    nationalityText: "Nazionalità",
    typeOfPermitText: "Tipo di permesso",
    dateOfRequestText: "Data della richiesta",
    reasonForPermitText: "Motivo del permesso",
    permitNumberText: "N° del permesso",
    policeHeadquartersOfText: "Questura di",

    fractionationText: "Frazione",
    townshipText: "Comune",

    butler: "Maggiordomo",
    chiefChef: "Capo cuoco",
    instructor: "Istitutore",
    houseManager: "Direttore Di Casa",
    domicileDifferentToResident: "Domicilio differente dalla residenza", // Domicile different to resident violaion
    selectIfDomicileDifferentToResident: "Selezionare in caso di domicilio diverso dalla residenza", // Select if domicile is different to resident

    employeeCreatedSuccessfullyText: "Lavoratore creato con successo",
    employerCreatedSuccessfullyText: "Datore di lavoro creato con successo",
    create: "Create",
    yesText: "Sì",
    noText: "No",
    sexFemaleText: "Femmina",
    sexMaleText: "Maschio",
    sexNotPreferenceText: "Non ho preferenze",
    countryUEText: "UE",
    countryUEExtraText: "Extra UE",
    alreadyAsstContractedText: "Ci sono altri assistenti gia’ contrattualizzati",
    personalCarePrefSexText: "Preferenze sesso personale assistenziale",
    agePreferenceRangeText: "Preferenza eta’(range)",

    datePattern: "/^[0-3]\d\/[0-1]\d\/-?[\d]+$/",
    dateFormat: "DD/MM/YYYY",
    dateFormatMask: "##/##/####",
    dateMondayShort: "Lun",
    dateTuesdayShort: "Mar",
    dateWednesdayShort: "Mer",
    dateThursdayShort: "Gio",
    dateFridayShort: "Ven",
    dateSaturdayShort: "Sab",
    dateSundayShort: "Dom",

    dateJanuary: "Gennaio",
    dateJanuaryShort: "Gen",
    dateFebruary: "Febbraio",
    dateFebruaryShort: "Feb",
    dateMarch: "Marzo",
    dateMarchShort: "Mar",
    dateApril: "Aprile",
    dateAprilShort: "Apr",
    dateMay: "Maggio",
    dateMayShort: "Mag",
    dateJune: "Giugno",
    dateJuneShort: "Giu",
    dateJuly: "Luglio",
    dateJulyShort: "Lug",
    dateAugust: "Agosto",
    dateAugustShort: "Ago",
    dateSeptember: "Settembre",
    dateSeptemberShort: "Set",
    dateOctober: "Ottobre",
    dateOctoverShort: "Ott",
    dateNovember: "Novembre",
    dateNovemberShort: "Nov",
    dateDecember: "Dicembre",
    dateDecemberShort: "Dec",

    requiredField: "Informazione obbligatoria",
    year: "Anno",
    qualification: "Qualifica",
    level: "Livello",
    withDomesticPartnership: "Con convivenza",
    date: "Data",
    reportStartDate: "Data inizio rapporto",
    reportEndDate: "Data fine rapporto",
    employerReference: "Riferimenti datore di lavoro (Nome, Cognome, Recapito telefonico, Email)",
    nameSurname: "Nome cognome",
    telephoneNumber: "Numero telefonico",
    mail: "Mail",
    startReport: "Inizio rapporto",
    endReport: "Fine rapporto",
    add: "Aggiungi",
    editButton: "Modifica",
    reference: "Riferimenti",
    partnership: "Convivenza",
    assistanceExperiencesNonSelfSufficientPersons: "Esperienze di assistenza a persona non autosufficiente",
    characteristicsPreviousExperiences: "Caratteristiche delle precedenti esperienze",
    elderly: "Anziani",
    withDisabilities: "Disabili",

    writtenLevel: "Livello scritto",
    spokenLevel: "Livello parlato",
    otherLanguages: "Altre lingue",
    enough: "Sufficiente",
    good: "Buono",
    great: "Ottimo",

    selectAnOption: "Seleziona una opzione",
    noResults: "Nessun risultato",
    close: "Chiudi",
    cancel: "Cancella",
    addWorkExperience: "Aggiungi esperienza",
    none: "Nessuno",

    township: "Comune",
    townshipErrorMessage: "Campo Comune obbligatorio",
    fractionationErrorMessage: "Campo Frazione obbligatorio",
    coincidesWithTheEmployersResidence: "Coincide con la residenza del datore di lavoro",
    coincidesWithTheEmployersResidenceErrorMessage: "Selezione Coincide con la residenza del datore di lavoro obbligatoria",

    isTheEmployerOwnerTheHouse: "Il datore di lavoro e’ proprietario della casa?",
    inCasesAssistanceThePersonTheEmployerIs: "In casi di assistenza alla persona, il datore di lavoro e’",
    isCivilInvalidOrCivilBlind: "Il datore di lavoro e’ grande invalido di guerra o del lavoro ovvero mutilato o invalido civile ovvero cieco civile? (Con Ass. di Accomp. legge 18/80, 508/88)",
    parent: "Genitore",
    tutor: "Tutore",
    relative: "Parente",
    son: "Figlio",
    spouse: "Coniuge",

    selfSufficientText: "Autosufficiente",
    disabledPersonText: "Persona disabile",
    disabledPersonExplanation: "Se no compilare la scheda non autosufficienza",
    familyAsstNonSelfSuffPeopleNonFormedCareerCoverageDaysOfRestText: "Assistente familiare che assiste persone non autosufficienti (Badante non formato/a) (Copertura giorni di riposo)",
    familyAsstNonSelfSuffPeopleFormedCareerCoverageDaysOfRestText: "Assistente familiare che assiste persone non autosufficienti (Badante formato/a)",
    familyAsstEducatorRestDayCoverageText: "Direttore di casa (Copertura giorni di riposo)",
    familyAsstPersonNonAutosufficientiFormatoText: "Assistente familiare che assiste persone non autosufficienti (badante formato/a) (copertura giorni di riposo)",

    childSex: "Sesso bambino",
    assistedSex: "Sesso assistito",
    ageChild: "Eta’ bambino",
    ageAssisted: "Eta' assistito",
    ageChildErrorMessage: "Campo Eta’ bambino obbligatorio",
    ageAssistedErrorMessage: "Campo Eta’ assistito obbligatorio",
    sportsActivities: "Attivita’ sportive",
    recreationalActivities: "Attivita’ ricreative",
    allergies: "Allergie",
    specialFeeding: "Alimentazione particolare",
    eatAlone: "Mangia da solo",
    singleText: "Nubile/Celibe",
    marriedText: "Coniugato/a",
    widowerText: "Vedovo/a",
    divorcedText: "Divorziato/a",
    maritalStatusText: "Stato Civile",

    educationalQualification: "Titolo di studio",
    noPreference: "Nessuna preferenza",
    graduation: "Laurea",
    middleSchoolDiploma: "Licenza media",
    higherLicense: "Licenza superiore",
    sexOfTheBabySister: "Sesso della baby sitter",
    woman: "Donna",
    man: "Uomo",
    ageRange: "Fascia di età’",

    secondLanguage: "Seconda lingua",
    indispensable: "Indispensabile",
    optional: "Facoltativa",
    language: "​​Lingua",
    languageIsRequired: "​​Lingua obbligatoria",

    portuguese: "Portoghese",
    polish: "Polacco",

    toBeFilledInOnlyInCaseOfNonSelfSufficiency: "Da compilare solo in caso di non autosufficienza",
    internalMobilityInTheHome: "Mobilità’ interna in casa",
    tripodStick: "Bastone tripode",
    electricWheelchair: "Carrozzina elettrica",
    manualWheelchair: "Carrozzina manuale",
    crutches: "Stampelle",
    walker: "Girello",
    walkingFrame: "Deambulatore",
    sittingOrBedMobility: "Mobilità’ da seduto o da letto",
    electricArmchair: "Poltrona elettrica",
    lifter: "Sollevatore",
    orthopedicBed: "Letto ortopedico",
    movesAloneInTheBed: "Si sposta da solo dentro il letto",
    externalMobility: "Mobilità’ esterna",
    personalHygiene: "Igiene personale",
    notSelfSufficient: "Non autosufficiente",
    nutrition: "Nutrizione",
    cognitiveDeficits: "Deficit cognitivi",
    communicationOfThePatient: "Comunicazione dell’assistito",
    abilityToExpressPreferences: "Capacita’ di espressione delle preferenze",
    diseases: "Patologie",
    specialTherapies: "Particolari terapie",

    trialPeriod: "Periodo di prova",
    startingWorkRelationship: "Inizio rapporto di lavoro",
    termOfEmploymentRelationship: "Termine rapporto di lavoro (Se a tempo determinato)",
    nameLastName: "Presso",
    postalCode: "Cap",

    indicateTheDay: "Indicare il giorno",
    selectDay: "Seleziona Giorno",
    sundayArt: "Domenica (Salvo Art. 14, Comma 4 – Ccnl)",
    holyDatePatron: "Data Santo patrono",

    hourlyIfTheRelationshipIsNotCoLive: "Oraria se il rapporto è non convivente",
    monthlyIfTheRelationshipIsCoLive: "Mensile se il rapporto è convivente",
    grossRemunerationAmount: "Retribuzione lorda importo",
    possibleSuperminimum: "Eventuale superminimo",
    howMuch: "Quanto",
    possibleIndemnity: "Eventuale indennità’",
    table: "Tabella",
    monthlyAdvanceThirteenthInstallment: "Anticipo mensile rateo tredicesima",
    availabilityToPayAMaximum70Annual: "Disponibilita’ a liquidare tfr massimo 70% annuo",
    percentage: "Percentuale",
    termsOfPayment: "Modalita’ di pagamento",
    transfer: "Bonifico",
    cash: "Contanti",
    check: "Assegno",

    employerPayboxEveryMonth: "I contributi vengono versati trimestralmente dal datore di lavoro. vuoi trattenere mensilmente nella busta paga del lavoratore, la quota inps/cassacolf di sua competenza?",
    presenceOfCamerasInTheHome: "Presenza di telecamere in casa",
    presenceOfAnimalsInTheHouse: "Presenza di animali in casa",
    availabilityInExtraordinaryHolidays: "Disponibilita’ a straordinari festivita’",
    theTaskOfAssistantToNonSelfSufficientPersonMsg: "Ai soli fini dello svolgimento della mansione di assistente a persona non autosufficiente, il datore di lavoro richiede il diploma di formazione professionale di 500 ore (Art. 9 Ccnl -Note a verbale, Lett. C)",
    dsLevelRecruitment: "Assunzione livello ds",
    aDiplomaOfTrainingIsRequired: "Si richiede il diploma di formazione",
    checkAnOption: "Selezionare una delle opzioni disponibili",
    checkManyOptions: "Selezionare una o più delle opzioni disponibili",

    enterEmployerFirstLastName: "Inserire Nome e Cognome del datore di lavoro",
    enterEmployeeFirstLastName: "Inserire Nome e Cognome del lavoratore",
    advancedSearch: "Ricerca avanzata",
    save: "Salva",
    update: "Aggiorna",
    reset: "Resetta",
    print: "Stampa",
    view: "Visualizza",
    edit: "Modifica",
    terminate: "Termina",

    selectEmployerAndEmployee: "Seleziona datore di lavoro e lavoratore",
    selectEmployerAndEmployeeDescription: "Seleziona descrizione datore di lavoro e lavoratore",

    messageForPrintOnEditOperation: "L'opzione di stampa utilizzerà i dati già memorizzati e non i dati in aggiornamento. Vuoi continuare?",
    invalidDateRangeErrorMsg: "Inserire un intervallo di date valido",

    noWorkExperiencesAdded: "Nessuna esperienza lavorativa aggiunta",
    noTrainingCourseAdded: "Nessuna formazione aggiunta",

    selectSection: "Seleziona sezioni opzionali",
    selectSectionDescription: "Descrizione sezioni opzionali",
    selectSectionStepName: "Sezioni opzionali",

    searchResultFound: "Risulati della ricerca",
    collapseAll: "Raggruppa",
    noEmployerFound: "Nessun datore di lavoro trovato",
    searchEmployer: "Ricerca datore di lavoro",
    notFoundMsg: "Nessun record trovato",
    items: "Records",
    typeInfoFindEmployers: "Digita ricerca datori di lavoro",
    typeInfoFindCandidates: "Digita ricerca candidati",
    employerSingular: "Datore di lavoro",
    searchCandidates: "Ricerca candidati",
    noCandidatesFound: "Nessun candidato trovato",

    // new - need to add authetication messages
    invalidCredentials: "Credenziali non valide",
    userNotFoundDatabase: "L'utente inserito non e' presente nel database",
    invalidUsername: "Username non valido",

    formSavedSuccessfully: "Form salvato correttamente",
    formSaveFailed: "Si è verificato un errore durante il salvataggio del form",
    formUpdatedSuccessfully: "Form aggiornato correttamente",
    formUpdatedFailed: "Si è verificato un errore durante l'aggiornamento del form",
    reportDownloadedSuccessfully: "Download completato con successo",
    reportDownloadFailed: "Errore durante il download del report",
    idGetFailed: "Errore durante il recupero dei dati corrispondenti all'Id fornito",
    listGetFailed: "Errore durante il recupero della lista richiesta",
    reportPrintingProcessing: "Stiamo processando il report richiesto, si prega di attendere ...",
    recordRetrieveProcessing: "Stiamo processando il report richiesto, si prega di attendere ...",

    logOut: "Esci",
    selectEmployerToContinue: "Selezionare un datore di lavoro per continuare",
    selectCandidatesToContinue: "Selezionare uno o più candidati per continuare",

    findCandidatesByFilters: "Trova candidati in base ai filtri",
    fromDate: "Da",
    toDate: "A",
    filter: "Filtro",
    total: "Totale",

    alreadyRecruitedByAnEmployer: "Già parte di un processo di selezione in corso",
    findByCompany: "Intero Network DOMINA",
    findByCompanyAgency: "Propria Agenzia",
    loginFailed: "Autenticazione fallita. Controlla le credenziali di accesso e riprova.",

    uploadUserPhoto: "Carica foto candidato",
    animalsDescription: "Descrizione degli animali",
    animalsDescriptionIsRequired: "Descrizione degli animali richieste",
    familyAssistantAssistingSelfSufficientBadante: "Assistente familiare che assiste persone autosufficienti (badante)",
    asstFamilyEducatorFormat: "Assistente familiare educatore formato (copertura giorni di riposo)",
    agency: "Agenzia",
    noDataToShowFor: "Nessun dato da mostrare per",
    noDataToShow: "Nessun dato da mostrare",
    itemSelected: "Record selezionato",
    itemsSelected: "Records selezionati",
    noItemSelected: "Nessun record selezionato",
    itemsPerPage: "Records per pagina",
    previousSelection: "Selezione precedente",
    deleteSelectedItems: "Cancella record selezionati",
    previousSelectionExtra: "Seleziona uno o più records da cancellare dalla lista",

    recruitSaveSuccessfully: "Processo di selezione salvato con successo",
    recruitFailedToSave: "Errore durante il salvataggio del processo di selezione",
    candidatesRemovedRecruitSuccess: "Candidato rimosso con successo dal processo di selezione in corso",
    candidatesFailedRemovedForRecruit: "Errore durante la rimozione del candidato dal processo di selezione in corso",

    sureDeleteItemsMessage: "Sei sicuro di voler rimuovere definitivamente i records selezionati?",
    delete: "Cancella",
    changeEmployer: "Cambia datore di lavoro",
    changeEmployee: "Cambia impiegato",
    alreadyEmployerHasAContract: "Datore di lavoro associato ad un contratto attivo",

    messageChangeEmployer: "Creando un nuovo contratto con un nuovo datore di lavoro. Sei sicuro di voler cambiare il datore di lavoro?",
    messageChangeEmployee: "Creando un nuovo contratto con un nuovo candidato. Sei sicuro di voler cambiare impiegato?",
    uploadFile: "Carica file",
    privacyFile: "Privacy file",
    pleaseSelectJPGImage: "Seleziona un'immagine formato JPG",
    uploadDocuments: "Carica documento",
    uploadDocumentFront: "Carica fronte documento",
    uploadDocumentBack: "Carica retro documento",
    downloadFiles: "Scarica files",
    documentFiles: "Documenti",
    share: "Condividi",
    shared: "Condiviso",
    dateOfIssue: "Data emissione",
    dateOfIssueIsRequired: "Data emissione obbligatoria",

    reliance: "Affidamento",
    assistanceMinors: "Assistenza minori DL 8.1.07 n. 5 art 2 c.6",
    waitingCircularOccupations: "Attesa occupazioni circolari dip. lib. civ",
    sportActivity: "Attivita’ sportiva",
    medicalCare: "Cure mediche",
    minorFamily: "Famiglia minore 14/18",
    minorIntegration: "Integrazione minore",
    workParticularCasesOfTheTU: "Lavoro casi particolari lett. e art. 27 t.u.i.",
    artisticWorks: "Lavori di tipo artistico",
    seasonalWork: "Lavoro stagionale",
    multiYearSeasonalWorkDpr: "Lavoro stagionale pluriennale dpr 394/99",
    subordinateWork: "Lavoro subordinato",
    employmentExpectedEmployment: "Lavoro subordinato – attesa occupazione",
    minorAge: "Minore eta’",
    volunteerMissionLegislativeDecree: "Missione volontariato d.l.vo 154/07",
    businessReasonsSelfEmployment: "Motivi commerciali/lavoro autonomo",
    reasonsStudy: "Motivi di studio",
    familyReasons: "Motivi familiari",
    humanitarianReasonsArt11: "Motivi umanitari art. 11 lettera c-ter",
    humanitarianReasonsArt18: "Motivi umanitari art. 18 d.l. 286/98",
    humanitarianReasonsI: "Motivi umanitari l. 31/07/2005 nr. 155",
    permitStayLongPeriod: "Permesso soggiorno ce sogg. lungo periodo",
    subsidiaryProtection: "Protezione sussidiaria art. 17 d.lvo 251",
    scientificResearch: "Ricerca scientifica",
    requestPoliticalActivity: "Rich. asilo politico-attivita’ lavorativa",
    reconStatelessPerson: "Ricon. apolide-dpr 334/04 art. 1 c. 1 let. c",
    internship: "Tirocinio",
    workingHoliday: "Vacanza lavoro",

    authorizeCandidate: "Autorizza candidato",
    expiryDate: "Data di scadenza",
    noAgencies: "Nessuna agenzia",
    viewDetails: "Visualizza",

    reportUserDeleteProcessing: "Stiamo rimuovendo l'utente selezionato. Si prega si attendere ...",
    reportUserDeleteSuccessfully: "L'utente e' stato rimosso con successo",
    reportContractTerminateSuccessfully: "Contratto terminato con successo",
    reportUserDeleteFailed: "Errore durante la rimozione dell'utente",
    reportContractTerminateFailed: "Errore durante la chiusura del contratto",
    reportContractDeleteProcessing: "Stiamo rimuovendo il contratto selezionato. Si prega di attendere ...",
    reportContractTerminateProcessing: "Stiamo terminando il contratto selezionato. Si prega di attendere ...",

    msgAuthorizeSuccessfully: "Il candidato e' stato autorizzato con successo",
    msgEditAuthorizeSuccessfully: "L'autorizzazione del candidato e' stata aggiornata con successo",
    msgDeleteAuthorizeSuccessfully: "L'autorizzazione del candidato e' stata rimossa con successo",

    msgAuthorizeFailed: "Errore durante l'autorizzazione del candidato",
    msgEditAuthorizeFailed: "Errore durante l'aggiornamento dell'autorizzazione del candidato",
    msgDeleteAuthorizeFailed: "Errore durante la rimozione dell'autorizzazione del candidato",

    sureDeleteCandidateMessage: "Sicuro di voler cancellare il candidato?",
    askMoreInformation: "Richiedi maggiori dettagli",

    sureDeleteEmployerMessage: "Sicuro di voler cancellare il datore di lavoro?",
    sureTerminateEmployerMessage: "Sicuro di voler terminare il contratto?",

    contractTerminated: "Contratto terminato, non più in essere",
    startDateAndYearDifferent: "L'anno deve essere uguale all'anno della data di inizio rapporto."
};
